/**
 * Build compact pagination labels: page numbers and 'ellipsis' for gaps.
 * @param {number} currentPage - 1-based
 * @param {number} totalPages
 * @returns {(number|'ellipsis')[]}
 */
export function getPaginationItems(
    currentPage,
    totalPages,
    {
        siblingCount = 1,
        boundaryLeft = 5,
        boundaryRight = 4,
        compactThreshold = 10,
    } = {}
) {
    if (totalPages < 1) return [];
    if (totalPages <= compactThreshold) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const add = (set, n) => {
        if (n >= 1 && n <= totalPages) set.add(n);
    };
    const pages = new Set();

    for (let i = 1; i <= Math.min(boundaryLeft, totalPages); i++) add(pages, i);

    const rightStart = Math.max(1, totalPages - boundaryRight + 1);
    for (let i = rightStart; i <= totalPages; i++) add(pages, i);

    for (let i = currentPage - siblingCount; i <= currentPage + siblingCount; i++) {
        add(pages, i);
    }

    const sorted = [...pages].sort((a, b) => a - b);
    const out = [];
    for (let i = 0; i < sorted.length; i++) {
        if (i > 0 && sorted[i] - sorted[i - 1] > 1) out.push('ellipsis');
        out.push(sorted[i]);
    }
    return out;
}
